function BAMVersionMismatchError(message) {
  this.name = 'BAMVersionMismatchError'
  this.message = message
  this.clientMessage = message
  this.stack = new Error().stack
}
BAMVersionMismatchError.prototype = new Error()

export default BAMVersionMismatchError
